export const UrlConfig = {
  root: {
    title: "Root",
    clientes: {
      url: "/root/clientes",
      title: "Clientes",
    },
  },

  dashboard: {
    title: "Dashboard",
    url: "/dashboard",
  },
  leads: {
    title: "Leads",
    leads: {
      url: "/leads",
      title: "Leads",
      subsTitle: "Controle todos seus leads",
    },
  },

  landingPages: {
    title: "Landing Pages",

    landingPages: {
      url: "/landingPages",
      title: "Landing Pages",
      subsTitle:
        "Formulários/Landing Pages de capturas de Leads, utilizados para divulgação de campanhas",
    },
  },

  campaign: {
    title: "Campanha",

    groupLeads: {
      url: "/groupLeads",
      title: "Grupos de Leads",
    },

    campaigns: {
      url: "/campaigns",
      title: "Campanhas",
    },

    campaign: {
      url: "/campaign/:id",
      title: "Campanha",
    },
    instancesWhats: {
      url: "/instancesWhats",
      title: "Conexões WhatsApp",
    },
  },

  plans: {
    title: "Planos - Pagamentos",
    url: "/payments",
  },
  profile: {
    title: "Perfil",
    subsTitle: "Configurações pessoais",
    url: "/profile",
  },

  help: {
    title: "Dúvidas/suporte",
    url: "/help",
  },

  config: {
    title: "Configurações",
    url: "/config/details",
  },

  relatoriosProducao: {
    title: "Relatórios",

    producaoContract: {
      url: "/report/productionContract",
      title: "Produção contrato",
    },

    confirmationProducer: {
      url: "/report/confirmationProducer",
      title: "Confirmação parcelas",
    },
  },

  comissao: {
    title: "Comissões",

    corretora: {
      url: "/Comissoes/grades",
      title: "Grade de Comissões",
    },
    cadastros: {
      url: "/Comissoes/cadastros",
      title: "Cadastros",
      subsTitle: "Gerencie os planos que você vende",
    },
  },

  drive: {
    title: "Drive",

    drive: {
      url: "/drive",
      title: "Drive",
    },
  },

  lancamentos: {
    title: "Lançamentos",

    contratos: {
      url: "/Lancamentos/contratos",
      title: "Contratos",
    },

    contrato: {
      url: "/Lancamentos/contrato/:id",
      title: "Contrato interno",
    },
    contratoParcelasInterno: {
      url: "/Lancamentos/contrato/parcelas/:id",
      title: "Parcelas contrato",
    },

    parcelas: {
      url: "/Lancamentos/parcelas",
      title: "Parcelas",
    },
  },
};
